import './scss/banner-fixo.scss'
import type { BannerFixoAppProps, BannerFixoProps } from "./banner-fixo.props"
import Modelo01 from './components/modelo01/Modelo01'
import Modelo02 from './components/modelo02/Modelo02'
import Modelo03 from './components/modelo03/Modelo03'
import Modelo04 from './components/modelo04/Modelo04'
import Modelo05 from './components/modelo05/Modelo05'
import Modelo06 from './components/modelo06/Modelo06'
import Modelo07 from './components/modelo07/Modelo07'
import Modelo08 from './components/modelo08/Modelo08'
import Modelo09 from './components/modelo09/Modelo09'
import Modelo10 from './components/modelo10/Modelo10'
import Title from './components/Title'

async function trataDados(banners: BannerFixoProps[]) {
    return banners.map(banner => {
        if (banner.opcoes && typeof banner.opcoes === 'string') {
            try {
                banner.opcoes = JSON.parse(banner.opcoes)
            } catch (e: unknown) {
                console.error(`Erro ao parsear opcoes do banner: ${banner.id}`, e)
                return banner
            }
        }
        return banner
    })
}

export default class BannerFixoApp {
    constructor(data: BannerFixoAppProps) {
        this.init(data)
    }

    async init({ id, device, modeloId, banners, title = '' }: BannerFixoAppProps) {
        const el = document.getElementById(id)
        if (!el) {
            console.error(`Banner fixo, identificador não encontrado: ${id}`)
            return
        }

        banners = await trataDados(banners)

        const components = {
            1: Modelo01,
            2: Modelo02,
            3: Modelo03,
            4: Modelo04,
            5: Modelo05,
            6: Modelo06,
            7: Modelo07,
            8: Modelo08,
            9: Modelo09,
            10: Modelo10,
        }

        const SelectedComponent = components[modeloId]

        if (SelectedComponent) {
            // @ts-expect-error ReactDOM inserido no base.html
            const root = ReactDOM.createRoot(el)
            root.render(
                <>
                    <Title title={title} />
                    <SelectedComponent data={{ banners, device }} />
                </>
            )
        }
    }
}
